export * from '@sayyoo/services-pay';



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-http-apis/lib/pay.js
// module id = 11uw
// module chunks = 256